import { Box, Typography } from '@mui/material';
import Grid from '@mui/material/Unstable_Grid2';
import { Order } from '../../../Models';

export default function PatientInfoSection({ order }: { order: Order }) {
    return (
        <Box>
            <Typography variant="subtitle1" gutterBottom>
                🧍 Cliente
            </Typography>
            <Grid container spacing={2} alignItems="flex-start">
                <Grid>
                    <Typography variant="body2" color="textSecondary">
                        Nombre
                    </Typography>
                    <Typography variant="body1">{order.patient?.fullname || ''}</Typography>
                </Grid>
                <Grid>
                    <Typography variant="body2" color="textSecondary">
                        Teléfono
                    </Typography>
                    <Typography variant="body1">{order.patient?.phone_number || ''}</Typography>
                </Grid>
                <Grid>
                    <Typography variant="body2" color="textSecondary">
                        DNI
                    </Typography>
                    <Typography variant="body1">{order.patient?.national_id || ''}</Typography>
                </Grid>
            </Grid>
        </Box>
    );
}
